// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, recordOf } from "@altostra/type-validations";
import { number } from "@altostra/type-validations/lib/primitives";

export const isCampaignAggregateStatsResult = objectOf({
  total_sent: number,
  total_opens: number,
  sent_counts: arrayOf(number),
  open_counts: arrayOf(number),
  daily_dates: arrayOf(number),
  upcoming_message: recordOf({
    value: objectOf({
      email: number,
      push: number,
      slideup: number,
      webhook: number,
    }),
  }),
  upcoming_dates: arrayOf(number),
});
